<template>
  <PuSkeleton :loading="isLoading" :count="1" width='100%' height="240px">
    <line-chart
            :chartData.sync='chartUpdated'
            :maj.sync = update
    />
  </PuSkeleton>
</template>


<script>
  import lineChart from '../chart/LineBig'
  import moment from 'moment'
  moment.locale('fr');
  //
  export default {
    name: "CardBig",
    components:{
      lineChart
    },
    props:{
      data:[Array,Object],
      dataIndex: String,
      codePtf: String,
      period:String,
      type: {
        type: String,
        default: 'parcourir',
      },
      isLoad:{
        type:Boolean,
        default: true
      },
      isNegative:{
        default: false
      },
      isObjective:{
        default: false
      }
    },
    data(){
      return {
        isLoading:true,
        chartUpdated:{},
        update:0,
        totalWeek: 52,
        chart : {
          datasets: [ {
            data: [],
            borderColor: "rgb(0,106,162)",
            fill: false,
            pointRadius: 3
          },
            {
              data: [],
              borderColor: "rgb(128,128,128)",
              fill: false,
              pointRadius: 3
            },
            {
              data: [],
              borderColor: "rgb(240,180,15)",
              fill: false,
              pointRadius: 3
            }
          ]
        },
      }
    },
    created(){
      this.isLoading = this.isLoad;
    },
    methods:{
      setData(period){
        if (!this.chart.datasets) {
          console.log('no datasets');
          return;
        }

        if (!this.data) {
          console.log('no data');
          return;
        }

        if(period != this.period){
          this.$emit('changePeriod', period);
        }
        if (this.isNegative){
          this.chart.datasets[0].borderColor = 'rgb(240,180,15)';
        } else {
          this.chart.datasets[0].borderColor = "rgb(0,106,162)";
        }
        this.chart.datasets[0].data = [];
        this.chart.datasets[1].data = [];
        this.chart.datasets[2].data = [];
        this.chart.labels = [];
        //
        if(this.data[0]?.objectifValue){
          this.chart.datasets[2].borderColor = "rgb(240,180,15)";
          this.chart.datasets[2].borderDash = [10, 10];
          this.data.map(element => this.chart.labels.push(element.date));
          this.chart.datasets[2].data = this.data.map(() => this.data[0].objectifValue);
        }

        delete this.data.infos;
        //on push les dates
        if (this.type === 'concours') {
          Object.values(this.data).map(element => this.chart.labels.push(element.date));
          this.chart.datasets[0].data = Object.values(this.data).map((element) => {
            return element.value;
          });
          this.chart.datasets[1].data = Object.values(this.data).map((element) => {
            return element.value;
          });
        } else {
          Object.keys(this.data).map(element => this.chart.labels.push(element));
          this.chart.datasets[0].data = Object.values(this.data).map((element) => {
            return element[this.codePtf ?? 'total']?.[this.dataIndex]?.[this.getResultNString()]?.toLocaleString();
          });
          this.chart.datasets[1].data = Object.values(this.data).map((element) => {
            return element[this.codePtf ?? 'total']?.[this.dataIndex]?.[this.getResultN1MString()]?.toLocaleString();
          });
        }


        this.chartUpdated = this.chart;
        //for forcing the update of chart.js
        //it's not conventional
        this.update+= 1;
      },
      getResultNString() {
        return this.dataIndex + '_c';
      },
      getResultN1MString() {
        return this.dataIndex + '_b';
      },
    },
    watch : {
      'isLoad' : function (){
        this.isLoading = this.isLoad;
        this.setData(this.period);
      }
    },
  }
</script>
